import { observable, action } from "mobx";
import agent from "../agent";

class sendBookingDetailsStore {

    
    @action
    getByProfileIdBookingId(profileId, bookingId) {
        return agent.SendBookingDetails.getByProfileIdAndBookingId(profileId, bookingId).then(action(result => {

            return result;
        }));
    };

    
    

}

export default new sendBookingDetailsStore();
